// TODO: GR-329 - THE TEMPLATE DOES NOT SEEM TO BE USED
// import itemCategoriesTemplate from "./itemCategories.template.html";

/*******************************************************************************
 * Controller: itemCategoriesController
 *
 * Controller for the categories view
 *******************************************************************************/
/* @ngInject */ export function ItemCategoriesController(
  $scope,
  $timeout,
  AddChangeItemCategoryDialog,
  Alert,
  BooksSvc,
  BusyScreen,
  ItemAdminGridStates,
  ItemAdminService,
  uiGridConstants
) {
  /*--------*/
  /* Flags. */
  /*--------*/
  /** Dialog Active flag. */ var categoryDialogActive = false;

  /*----------------------------------------------*/
  /* Template for the Actions column in the grid. */
  /*----------------------------------------------*/
  var actionsTemplate =
    '<div class="ui-grid-cell-contents ng-binding ng-scope"> ' +
    '<table><tr>' +
    '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-edit  csm-grid-space-target" title="Change Category" ng-click="grid.appScope.changeCategory(row.entity)"></span></td>' +
    '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-trash csm-grid-space-target" title="Delete Category" ng-click="grid.appScope.deleteCategory(row.entity)"></span></td>' +
    '</tr></table>' +
    '</div>';

  /*---------------------------------------------------------*/
  /* Template to add double click functionality to each row. */
  /*---------------------------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.changeCategory(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /*------------------------------*/
  /* Item categories grid options */
  /*------------------------------*/
  $scope.itemCategoriesGrid = {
    enableColumnMenus: false,
    enableRowSelection: true,
    enableFiltering: true,
    enableFullRowSelection: true,
    enableRowHeaderSelection: false,
    multiSelect: false,
    enableSelectAll: false,
    saveFilter: true,
    saveSort: true,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.NEVER,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    onRegisterApi: function (gridApi) {
      $scope.itemCategoriesGrid.api = gridApi;
    },
    rowTemplate: dblClickTemplate,
    data: [],
    columnDefs: [
      {
        field: 'category',
        maxWidth: 300,
        displayName: 'Item Category'
      },
      {
        field: 'description',
        displayName: 'Description'
      },
      {
        appScope: $scope,
        cellTemplate: actionsTemplate,
        displayName: 'Actions',
        enableFiltering: false,
        enableSorting: false,
        field: 'actions',
        pinnedRight: true,
        minWidth: 75,
        width: 75
      }
    ]
  };

  /*****************************************************************************
   * addCategory */
  /**
   * `Add Category` button click handler. Handles the adding of item categories.
   * Reloads list after add.
   *****************************************************************************/
  $scope.addCategory = function () {
    /*---------------------------------*/
    /* Dialog is already active, exit. */
    /*---------------------------------*/
    if (categoryDialogActive) return;

    /*---------------------------------------------*/
    /* Display dialog to modify selected category. */
    /*---------------------------------------------*/
    categoryDialogActive = true;
    AddChangeItemCategoryDialog.show()
      .then(function () {
        /*------------------------------*/
        /* Reload list and update grid. */
        /*------------------------------*/
        ItemAdminService.reloadCategories().then(function () {
          $scope.itemCategoriesGrid.data = ItemAdminService.getCategories();
        });
      })
      ['finally'](function () {
        categoryDialogActive = false;
      });
  };

  /*****************************************************************************
   * categorySelected */
  /**
   * Returns the selected row in the Item Categories grid.
   *
   * @return  Object  itemCategory
   *****************************************************************************/
  var categorySelected = function () {
    return $scope.itemCategoriesGrid.api.selection.getSelectedRows().shift();
  };

  /*****************************************************************************
   * changeCategory */
  /**
   * Handles the modifying of item categories. Reloads list after update.
   *
   * @param  category  Category to modify.
   *****************************************************************************/
  $scope.changeCategory = function (category) {
    /*--------------------------*/
    /* Nothing to modify, exit. */
    /*--------------------------*/
    if (!category) {
      Alert.error('Nothing to change');
      return;
    }

    /*---------------------------------*/
    /* Dialog is already active, exit. */
    /*---------------------------------*/
    if (categoryDialogActive) return;

    /*---------------------------------------------*/
    /* Display dialog to modify selected category. */
    /*---------------------------------------------*/
    categoryDialogActive = true;
    AddChangeItemCategoryDialog.show(category.id)
      .then(function () {
        /*------------------------------*/
        /* Reload list and update grid. */
        /*------------------------------*/
        ItemAdminService.reloadCategories().then(function () {
          $scope.itemCategoriesGrid.data = ItemAdminService.getCategories();
        });
      })
      ['finally'](function () {
        categoryDialogActive = false;
      });
  };

  /*****************************************************************************
   * deleteCategory */
  /**
   * Removes the provided category and reload the grid.
   *
   * @param  category  Category to delete.
   *****************************************************************************/
  $scope.deleteCategory = function (category) {
    if (!category) {
      Alert.error('Nothing to delete');
      return;
    }

    /*------------------------------*/
    /* Confirm and remove category. */
    /*------------------------------*/
    Alert.confirm(
      'This action cannot be undone. Are you sure you want to remove Category: {0}?'.format(
        category.category
      )
    ).then(function () {
      BusyScreen.setBusy(true);
      BooksSvc.dropItemCategory(category.id)
        .then(
          function (resp) {
            /*--------------------------------------------------------*/
            /* Display success and load updated itemOptionMasterList. */
            /*--------------------------------------------------------*/
            Alert.success('Item category sucessfully removed.');
            ItemAdminService.reloadCategories().then(function () {
              $scope.itemCategoriesGrid.data = ItemAdminService.getCategories();
            });
          },
          /*--------------------------------------------------*/
          /* Server responded with an error. Display to user. */
          /*--------------------------------------------------*/
          function (resp) {
            Alert.error(
              resp.parsedResponse.message() || 'Error deleting this category',
              'Failed to remove category.'
            );
          }
        )
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    });
  };

  /*--------------------------------------*/
  /* Link the grid state and set the data */
  /*--------------------------------------*/
  ItemAdminGridStates.categories.init($scope.itemCategoriesGrid);

  $scope.itemCategoriesGrid.data = ItemAdminService.getCategories();
}
